import { transformRoutes } from '@backoffice-frontend/common'

const BaseApServiceSettingsAreaRoutes = {
  route: '/ap-service-settings',
  Show: {
    route: '/:serviceAreaId',
  },
}

export const ApServiceSettingsAreaRoutes = transformRoutes(
  BaseApServiceSettingsAreaRoutes,
)
